var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.className,attrs:{"id":'bf_endpoint_'+_vm.id}},_vm.$listeners),[_vm._t("default",function(){return [_c('div',[_vm._v(" "+_vm._s(_vm.id)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }